import React from "react";
import LanguageModal from "../../../components/modal/LanguageModal";
import PasswordModal from "../../../components/modal/PasswordModal";
import SelectAreaModal from "../../../components/modal/selectAreaModal";
import { getLangWord, langText } from "../../../recoil/lang";
import { Style } from "./style";
import { HeaderViewProps } from "./type";

const HeaderView = ({ props, hook }: HeaderViewProps) => {
  return (
    <>
      <Style>
        <div className="header">
          <div className="buttonWrap">
            {hook.theme.logo && (
              <button className="logoButton">
                <img
                  onClick={hook.handleLogoClick}
                  src={hook.theme.logo}
                  className="logoButton"
                  alt="knockkonck로고"
                />
              </button>
            )}
            <h3>{props.deviceArea ? props.deviceArea.name : ""}</h3>
            {hook.theme.area_name && (
              <img src={hook.theme.area_name} alt="areaIcon" />
            )}
          </div>
          <div className="buttonWrap">
            {!props.kioskMode && (
              <button className="longButton" onClick={hook.navigateHome}>
                {hook.theme.turn_off && (
                  <img src={hook.theme.turn_off} alt="turnoff" />
                )}
                {langText.storeSelector_turnOff[hook.lang]}
              </button>
            )}
            <button className="longButton" onClick={hook.navigateOrderStatus}>
              {hook.theme.order_status && (
                <img
                  className="bell"
                  src={hook.theme.order_status}
                  alt="orderStatus"
                />
              )}
              {langText.storeSelector_orderStatus[hook.lang]}
            </button>
            <button
              className="longButton"
              onClick={() => hook.setVisibleLanguage(true)}
            >
              <img
                src={`${
                  process.env.PUBLIC_URL
                }/knockknock/svg/lang/ic_lang_${getLangWord(hook.lang)}.svg`}
                alt="lang"
              />
              Language
            </button>
          </div>
        </div>
      </Style>
      <LanguageModal
        isVisible={hook.visibleLanguage}
        setVisible={hook.setVisibleLanguage}
      />
      <PasswordModal
        isVisible={hook.visiblePassword}
        setVisible={hook.setVisiblePassword}
        setVisibleSelectArea={hook.setVisibleSelectArea}
      />
      <SelectAreaModal
        isVisible={hook.visibleSelectArea}
        setVisible={hook.setVisibleSelectArea}
        storeId={hook.master?.store_id}
      />
    </>
  );
};
export default HeaderView;
